<template>
  <div class="bg-white border border-gray-200 rounded-lg" :class="[{ 'p-3': !noSpace }]" :style="accentStyle">
    <slot></slot>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  dark: Boolean,
  color: {
    type: String,
    value: 'bg-white',
  },
  noSpace: Boolean,
  accentColor: {
    type: String,
    default: '',
  },
})

const accentStyle = computed(() => {
  if (!props.accentColor) return {}
  return {
    boxShadow: `inset 6px 0 0 0 ${props.accentColor}`,
  }
})
</script>
